/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierPayAdjustments.ts               *
 *                                                                             *
 /*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/carrier-other-pay";

export class AutogenModelCarrierPayAdjustments<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierPayAdjustmentsFields> {
    constructor(ctor: RowConstructor) {
        super(endpointPath, ctor);
    }
}

export class AutogenRowCarrierPayAdjustments extends ModelRow<RowCarrierPayAdjustmentsFields> {
    constructor(values?: Partial<RowCarrierPayAdjustmentsFields>) {
        super(endpointPath, true, values);
    }
}

export interface RowCarrierPayAdjustmentsFields {
    amount: number;
    amount_c: string;
    amount_d: Date;
    amount_n: number;
    amount_r: number;
    carrier_rate_id: number;
    company_id: string;
    deduct_code_id: string;
    descr: string;
    id: string;
    rate: number;
    units: number;
}

